"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SelectHowToPayForProjectCard = void 0;
const vue_1 = require("vue");
const Button_1 = require("./common/Button");
const Card_1 = require("./card/Card");
const CardFinder_1 = require("../CardFinder");
const Tags_1 = require("../cards/Tags");
const CardOrderStorage_1 = require("./CardOrderStorage");
const PaymentWidgetMixin_1 = require("./PaymentWidgetMixin");
const PreferencesManager_1 = require("./PreferencesManager");
const TranslateMixin_1 = require("./TranslateMixin");
const CardName_1 = require("../CardName");
const Units_1 = require("../Units");
const constants_1 = require("../constants");
exports.SelectHowToPayForProjectCard = vue_1.default.component('select-how-to-pay-for-project-card', {
    props: {
        player: {
            type: Object,
        },
        playerinput: {
            type: Object,
        },
        onsave: {
            type: Function,
        },
        showsave: {
            type: Boolean,
        },
        showtitle: {
            type: Boolean,
        },
    },
    data: function () {
        let card;
        let cards = [];
        if (this.playerinput !== undefined &&
            this.playerinput.cards !== undefined &&
            this.playerinput.cards.length > 0) {
            cards = CardOrderStorage_1.CardOrderStorage.getOrdered(CardOrderStorage_1.CardOrderStorage.getCardOrder(this.player.id), this.playerinput.cards);
            card = cards[0];
        }
        if (card === undefined) {
            throw new Error('no card provided in player input');
        }
        return {
            cardName: card.name,
            card: card,
            cards: cards,
            cost: 0,
            tags: [],
            heat: 0,
            megaCredits: 0,
            mustSpendAtMost: 0,
            steel: 0,
            titanium: 0,
            microbes: 0,
            science: 0,
            floaters: 0,
            graphene: 0,
            asteroids: 0,
            plants: 0,
            spireScience: 0,
            warning: undefined,
            available: Units_1.Units.of({}),
        };
    },
    components: {
        Card: Card_1.Card,
        Button: Button_1.Button,
    },
    mixins: [PaymentWidgetMixin_1.PaymentWidgetMixin, TranslateMixin_1.TranslateMixin],
    mounted: function () {
        const app = this;
        vue_1.default.nextTick(function () {
            app.$data.card = app.getCard();
            app.$data.cost = app.$data.card.calculatedCost;
            app.$data.tags = app.getCardTags(),
                app.$data.mustSpendAtMost = app.getMegaCreditsMax();
            app.$data.megaCredits = app.$data.mustSpendAtMost;
            app.setDefaultValues();
        });
    },
    methods: {
        getCard: function () {
            const card = this.cards.find((c) => c.name === this.cardName);
            if (card === undefined) {
                throw new Error(`card not found ${this.cardName}`);
            }
            return card;
        },
        getCardTags: function () {
            const card = new CardFinder_1.CardFinder().getProjectCardByName(this.cardName);
            if (card === undefined) {
                throw new Error(`card not found ${this.cardName}`);
            }
            return card.tags;
        },
        setDefaultValues: function () {
            this.microbes = 0;
            this.floaters = 0;
            this.science = 0;
            this.steel = 0;
            this.titanium = 0;
            this.heat = 0;
            this.graphene = 0;
            this.asteroids = 0;
            this.plants = 0;
            this.spireScience = 0;
            const units = this.card.reserveUnits || Units_1.Units.EMPTY;
            let megacreditBalance = Math.max(this.cost - this.mustSpendAtMost + units.megacredits, 0);
            const deductUnits = function (availableUnits, unitValue, overpay = true) {
                if (availableUnits === undefined || availableUnits === 0) {
                    return 0;
                }
                const _tmp = megacreditBalance / unitValue;
                const balanceAsUnits = overpay ? Math.ceil(_tmp) : Math.floor(_tmp);
                const contributingUnits = Math.min(availableUnits, balanceAsUnits);
                megacreditBalance -= contributingUnits * unitValue;
                return contributingUnits;
            };
            const saveOverSpendingUnits = function (spendingUnits, unitValue) {
                if (spendingUnits === undefined || spendingUnits === 0 || megacreditBalance === 0) {
                    return 0;
                }
                const overSpendingAsUnits = Math.floor(Math.abs(megacreditBalance) / unitValue);
                const toSaveUnits = Math.min(spendingUnits, overSpendingAsUnits);
                megacreditBalance += toSaveUnits * unitValue;
                return toSaveUnits;
            };
            if (megacreditBalance > 0 && this.canUseMicrobes()) {
                this.microbes = deductUnits(this.playerinput.microbes, constants_1.DEFAULT_MICROBES_VALUE);
            }
            if (megacreditBalance > 0 && this.canUseFloaters()) {
                this.floaters = deductUnits(this.playerinput.floaters, constants_1.DEFAULT_FLOATERS_VALUE);
            }
            if (megacreditBalance > 0 && this.canUseScience()) {
                this.science = deductUnits(this.playerinput.science, 1);
            }
            if (megacreditBalance > 0 && this.canUseAsteroids()) {
                this.asteroids = deductUnits(this.playerinput.asteroids, 1);
            }
            if (megacreditBalance > 0 && this.canUseSpireScience()) {
                this.spireScience = deductUnits(this.playerinput.spireScience, constants_1.DEFAULT_SPIRE_SCIENCE_VALUE);
            }
            if (megacreditBalance > 0 && this.canUseGraphene()) {
                this.graphene = deductUnits(this.playerinput.graphene, constants_1.DEFAULT_GRAPHENE_VALUE);
            }
            this.available.steel = Math.max(this.player.steel - this.card.reserveUnits.steel, 0);
            if (megacreditBalance > 0 && this.canUseSteel()) {
                this.steel = deductUnits(this.available.steel, this.player.steelValue, true);
            }
            this.available.plants = this.player.plants;
            if (megacreditBalance > 0 && this.canUsePlants()) {
                this.plants = deductUnits(this.available.plants, constants_1.DEFAULT_PLANT_VALUE, true);
            }
            this.available.titanium = Math.max(this.player.titanium - this.card.reserveUnits.titanium, 0);
            if (megacreditBalance > 0 && this.canUseTitanium()) {
                this.titanium = deductUnits(this.available.titanium, this.player.titaniumValue, true);
            }
            this.available.heat = Math.max(this.availableHeat() - this.card.reserveUnits.heat, 0);
            if (megacreditBalance > 0 && this.canUseHeat()) {
                this.heat = deductUnits(this.available.heat, 1);
            }
            if (megacreditBalance - this.card.reserveUnits.megacredits < 0) {
                this.plants -= saveOverSpendingUnits(this.plants, constants_1.DEFAULT_PLANT_VALUE);
                this.steel -= saveOverSpendingUnits(this.steel, this.player.steelValue);
                this.floaters -= saveOverSpendingUnits(this.floaters, constants_1.DEFAULT_FLOATERS_VALUE);
                this.microbes -= saveOverSpendingUnits(this.microbes, constants_1.DEFAULT_MICROBES_VALUE);
                this.science -= saveOverSpendingUnits(this.science, 1);
                this.asteroids -= saveOverSpendingUnits(this.asteroids, 1);
                this.graphene -= saveOverSpendingUnits(this.graphene, constants_1.DEFAULT_GRAPHENE_VALUE);
                this.spireScience -= saveOverSpendingUnits(this.spireScience, constants_1.DEFAULT_SPIRE_SCIENCE_VALUE);
            }
            let finalmegaCreditsCost = this.cost;
            finalmegaCreditsCost -= (this.titanium || 0) * (this.player.titaniumValue || constants_1.DEFAULT_TITANIUM_VALUE);
            finalmegaCreditsCost -= (this.plants || 0) * constants_1.DEFAULT_PLANT_VALUE;
            finalmegaCreditsCost -= (this.steel || 0) * (this.player.steelValue || constants_1.DEFAULT_STEEL_VALUE);
            finalmegaCreditsCost -= (this.floaters || 0) * constants_1.DEFAULT_FLOATERS_VALUE;
            finalmegaCreditsCost -= (this.microbes || 0) * constants_1.DEFAULT_MICROBES_VALUE;
            finalmegaCreditsCost -= this.heat || 0;
            finalmegaCreditsCost -= this.science || 0;
            finalmegaCreditsCost -= this.asteroids || 0;
            finalmegaCreditsCost -= (this.graphene || 0) * constants_1.DEFAULT_GRAPHENE_VALUE;
            finalmegaCreditsCost -= (this.spireScience || 0) * constants_1.DEFAULT_SPIRE_SCIENCE_VALUE;
            this.megaCredits = Math.max(0, finalmegaCreditsCost);
        },
        availableHeat: function () {
            var _a, _b;
            const availableHeat = this.player.heat - ((_b = (_a = this.card) === null || _a === void 0 ? void 0 : _a.reserveUnits) === null || _b === void 0 ? void 0 : _b.heat);
            const stormcraft = this.player.corporationCards.find((c) => c.name === CardName_1.CardName.STORMCRAFT_INCORPORATED);
            if (stormcraft !== undefined && stormcraft.resources !== undefined) {
                return availableHeat + (stormcraft.resources * 2);
            }
            return availableHeat;
        },
        canUseHeat: function () {
            return this.playerinput.canUseHeat === true && this.availableHeat() > 0;
        },
        canUsePlants: function () {
            const martianLumberCorp = this.player.playedCards.find((c) => c.name === CardName_1.CardName.MARTIAN_LUMBER_CORP);
            if (this.card !== undefined && martianLumberCorp !== undefined && this.available.plants > 0) {
                if (this.tags.find((tag) => tag === Tags_1.Tags.BUILDING) !== undefined) {
                    return true;
                }
            }
            return false;
        },
        canUseSteel: function () {
            if (this.card !== undefined && this.available.steel > 0) {
                if (this.tags.find((tag) => tag === Tags_1.Tags.BUILDING) !== undefined) {
                    return true;
                }
            }
            return false;
        },
        canUseTitanium: function () {
            if (this.card !== undefined && this.available.titanium > 0) {
                if (this.tags.find((tag) => tag === Tags_1.Tags.SPACE) !== undefined) {
                    return true;
                }
            }
            return false;
        },
        canUseMicrobes: function () {
            if (this.card !== undefined && this.playerinput.microbes !== undefined && this.playerinput.microbes > 0) {
                if (this.tags.find((tag) => tag === Tags_1.Tags.PLANT) !== undefined) {
                    return true;
                }
            }
            return false;
        },
        canUseFloaters: function () {
            if (this.card !== undefined && this.playerinput.floaters !== undefined && this.playerinput.floaters > 0) {
                if (this.tags.find((tag) => tag === Tags_1.Tags.VENUS) !== undefined) {
                    return true;
                }
            }
            return false;
        },
        canUseScience: function () {
            var _a;
            if (this.card !== undefined && ((_a = this.playerinput.science) !== null && _a !== void 0 ? _a : 0) > 0) {
                if (this.tags.find((tag) => tag === Tags_1.Tags.MOON) !== undefined) {
                    return true;
                }
            }
            return false;
        },
        canUseAsteroids: function () {
            var _a;
            if (this.card !== undefined && ((_a = this.playerinput.asteroids) !== null && _a !== void 0 ? _a : 0) > 0) {
                if (this.cardName === CardName_1.CardName.ASTEROID_STANDARD_PROJECT || this.cardName === CardName_1.CardName.AQUIFER_STANDARD_PROJECT) {
                    return true;
                }
            }
            return false;
        },
        canUseSpireScience: function () {
            var _a;
            const standardProjectNames = [
                CardName_1.CardName.ASTEROID_STANDARD_PROJECT,
                CardName_1.CardName.AQUIFER_STANDARD_PROJECT,
                CardName_1.CardName.CITY_STANDARD_PROJECT,
                CardName_1.CardName.GREENERY_STANDARD_PROJECT,
                CardName_1.CardName.POWER_PLANT_STANDARD_PROJECT,
                CardName_1.CardName.POWER_PLANT_STANDARD_PROJECT_THORGATE,
                CardName_1.CardName.BUFFER_GAS_STANDARD_PROJECT,
                CardName_1.CardName.AIR_SCRAPPING_STANDARD_PROJECT,
                CardName_1.CardName.AIR_SCRAPPING_STANDARD_PROJECT_VARIANT,
                CardName_1.CardName.BUILD_COLONY_STANDARD_PROJECT,
                CardName_1.CardName.MOON_COLONY_STANDARD_PROJECT,
                CardName_1.CardName.MOON_COLONY_STANDARD_PROJECT_V2,
                CardName_1.CardName.MOON_MINE_STANDARD_PROJECT,
                CardName_1.CardName.MOON_MINE_STANDARD_PROJECT_V2,
                CardName_1.CardName.MOON_ROAD_STANDARD_PROJECT,
                CardName_1.CardName.MOON_ROAD_STANDARD_PROJECT_V2,
            ];
            if (this.card !== undefined && ((_a = this.playerinput.spireScience) !== null && _a !== void 0 ? _a : 0) > 0) {
                if (standardProjectNames.includes(this.cardName)) {
                    return true;
                }
            }
            return false;
        },
        canUseGraphene: function () {
            if (this.card !== undefined && this.playerinput.graphene !== undefined && this.playerinput.graphene > 0) {
                if (this.tags.find((tag) => tag === Tags_1.Tags.SPACE || tag === Tags_1.Tags.CITY) !== undefined) {
                    return true;
                }
            }
            return false;
        },
        cardChanged: function () {
            this.card = this.getCard();
            this.cost = this.card.calculatedCost || 0;
            this.tags = this.getCardTags();
            this.megaCredits = this.getMegaCreditsMax();
            this.setDefaultValues();
        },
        hasWarning: function () {
            return this.warning !== undefined;
        },
        hasCardWarning: function () {
            return this.card !== undefined && this.card.warning !== undefined;
        },
        showReserveMegaCreditsWarning: function () {
            var _a, _b;
            if (!this.canUseSteel() && !this.canUseTitanium())
                return false;
            if (((_b = (_a = this.card) === null || _a === void 0 ? void 0 : _a.reserveUnits) === null || _b === void 0 ? void 0 : _b.megacredits) === undefined)
                return false;
            if (this.card.reserveUnits.megacredits === 0)
                return false;
            return this.card.reserveUnits.megacredits > 0 && this.player.megaCredits < this.cost + this.card.reserveUnits.megacredits;
        },
        showReserveSteelWarning: function () {
            var _a, _b;
            return ((_b = (_a = this.card) === null || _a === void 0 ? void 0 : _a.reserveUnits) === null || _b === void 0 ? void 0 : _b.steel) > 0 && this.canUseSteel();
        },
        showReserveTitaniumWarning: function () {
            var _a, _b;
            return ((_b = (_a = this.card) === null || _a === void 0 ? void 0 : _a.reserveUnits) === null || _b === void 0 ? void 0 : _b.titanium) > 0 && this.canUseTitanium();
        },
        showReserveHeatWarning: function () {
            var _a, _b;
            return ((_b = (_a = this.card) === null || _a === void 0 ? void 0 : _a.reserveUnits) === null || _b === void 0 ? void 0 : _b.heat) > 0 && this.canUseHeat();
        },
        saveData: function () {
            const htp = {
                heat: this.heat,
                megaCredits: this.megaCredits,
                steel: this.steel,
                titanium: this.titanium,
                microbes: this.microbes,
                floaters: this.floaters,
                science: this.science,
                graphene: this.graphene,
                asteroids: this.asteroids,
                plants: this.plants,
                spireScience: this.spireScience,
            };
            if (htp.megaCredits > this.player.megaCredits) {
                this.warning = 'You don\'t have that many M€';
                return;
            }
            if (this.playerinput.microbes !== undefined && htp.microbes > this.playerinput.microbes) {
                this.warning = 'You don\'t have enough microbes';
                return;
            }
            if (this.playerinput.floaters !== undefined && htp.floaters > this.playerinput.floaters) {
                this.warning = 'You don\'t have enough floaters';
                return;
            }
            if (this.playerinput.science !== undefined && htp.science > this.playerinput.science) {
                this.warning = 'You don\'t have enough science resources';
                return;
            }
            if (this.playerinput.graphene !== undefined && htp.graphene > this.playerinput.graphene) {
                this.warning = 'You don\'t have enough graphene resources';
                return;
            }
            if (this.playerinput.asteroids !== undefined && htp.asteroids > this.playerinput.asteroids) {
                this.warning = 'You don\'t have enough asteroid resources';
                return;
            }
            if (this.playerinput.spireScience !== undefined && htp.spireScience > this.playerinput.spireScience) {
                this.warning = 'You don\'t have enough science resources';
                return;
            }
            if (htp.heat > this.availableHeat()) {
                this.warning = 'You don\'t have enough heat';
                return;
            }
            if (htp.titanium > this.player.titanium) {
                this.warning = 'You don\'t have enough titanium';
                return;
            }
            if (htp.plants > this.player.plants) {
                this.warning = 'You don\'t have enough plants';
                return;
            }
            if (htp.steel > this.player.steel) {
                this.warning = 'You don\'t have enough steel';
                return;
            }
            const totalSpentAmt = (constants_1.DEFAULT_FLOATERS_VALUE * htp.floaters) +
                (constants_1.DEFAULT_MICROBES_VALUE * htp.microbes) +
                (constants_1.DEFAULT_GRAPHENE_VALUE * htp.graphene) +
                (constants_1.DEFAULT_PLANT_VALUE * htp.plants) +
                (constants_1.DEFAULT_SPIRE_SCIENCE_VALUE * htp.spireScience) +
                htp.asteroids +
                htp.science +
                htp.heat +
                htp.megaCredits +
                (htp.steel * this.player.steelValue) +
                (htp.titanium * this.player.titaniumValue);
            if (totalSpentAmt < this.cost) {
                this.warning = 'Haven\'t spent enough';
                return;
            }
            if (totalSpentAmt > this.cost) {
                const diff = totalSpentAmt - this.cost;
                if (htp.titanium && diff >= this.player.titaniumValue) {
                    this.warning = 'You cannot overspend titanium';
                    return;
                }
                if (htp.plants && diff >= constants_1.DEFAULT_PLANT_VALUE) {
                    this.warning = 'You cannot overspend plants';
                    return;
                }
                if (htp.steel && diff >= this.player.steelValue) {
                    this.warning = 'You cannot overspend steel';
                    return;
                }
                if (htp.floaters && diff >= constants_1.DEFAULT_FLOATERS_VALUE) {
                    this.warning = 'You cannot overspend floaters';
                    return;
                }
                if (htp.microbes && diff >= constants_1.DEFAULT_MICROBES_VALUE) {
                    this.warning = 'You cannot overspend microbes';
                    return;
                }
                if (htp.science && diff >= 1) {
                    this.warning = 'You cannot overspend science resources';
                    return;
                }
                if (htp.spireScience && diff >= constants_1.DEFAULT_SPIRE_SCIENCE_VALUE) {
                    this.warning = 'You cannot overspend science resources';
                    return;
                }
                if (htp.asteroids && diff >= 1) {
                    this.warning = 'You cannot overspend asteroid resources';
                    return;
                }
                if (htp.graphene && diff >= constants_1.DEFAULT_GRAPHENE_VALUE) {
                    this.warning = 'You cannot overspend graphene resources';
                    return;
                }
                if (htp.heat && diff >= 1) {
                    this.warning = 'You cannot overspend heat';
                    return;
                }
                if (htp.megaCredits && diff >= 1) {
                    this.warning = 'You cannot overspend M€';
                    return;
                }
            }
            if (htp.megaCredits > this.player.megaCredits - this.card.reserveUnits.megacredits) {
                this.warning = 'Must save enough M€ for Reds';
                return;
            }
            const showAlert = PreferencesManager_1.PreferencesManager.load('show_alerts') === '1';
            if (totalSpentAmt > this.cost && showAlert) {
                const diff = totalSpentAmt - this.cost;
                if (confirm('Warning: You are overpaying by ' + diff + ' M€')) {
                    this.onsave([[
                            this.card.name,
                            JSON.stringify(htp),
                        ]]);
                }
                else {
                    this.warning = 'Please adjust payment amount';
                    return;
                }
            }
            else {
                this.onsave([[
                        this.card.name,
                        JSON.stringify(htp),
                    ]]);
            }
        },
        robotCard(card) {
            var _a;
            return (_a = this.player.selfReplicatingRobotsCards) === null || _a === void 0 ? void 0 : _a.find((r) => r.name === card.name);
        },
    },
    template: `<div class="payments_cont">

  <div v-if="showtitle === true">{{ $t(playerinput.title) }}</div>

  <label v-for="availableCard in cards" class="payments_cards">
    <input class="hidden" type="radio" v-model="cardName" v-on:change="cardChanged()" :value="availableCard.name" />
    <Card class="cardbox" :card="availableCard" :robotCard="robotCard(availableCard)"/>
  </label>

  <section v-trim-whitespace>
    <div v-if="hasCardWarning()" class="card-warning">{{ $t(card.warning) }}</div>

    <h3 class="payments_title" v-i18n>How to pay?</h3>

    <div class="payments_type input-group" v-if="canUsePlants()">
      <i class="resource_icon resource_icon--plants payments_type_icon" title="Pay with Plants"></i>
      <Button type="minus" :onClick="_=>reduceValue('plants', 1)" />
      <input class="form-input form-inline payments_input" v-model.number="plants" />
      <Button type="plus" :onClick="_=>addValue('plants', 1, this.available.plants)" />
      <Button type="max" :onClick="_=>setMaxValue('plants', this.available.plants)" title="MAX" />
    </div>

    <div class="payments_type input-group" v-if="canUseSteel()">
      <i class="resource_icon resource_icon--steel payments_type_icon" title="Pay with Steel"></i>
      <Button type="minus" :onClick="_=>reduceValue('steel', 1)" />
      <input class="form-input form-inline payments_input" v-model.number="steel" />
      <Button type="plus" :onClick="_=>addValue('steel', 1, this.available.steel)" />
      <Button type="max" :onClick="_=>setMaxValue('steel', this.available.steel)" title="MAX" />
    </div>
    <div v-if="showReserveSteelWarning()" class="card-warning" v-i18n>
    (Some steel is unavailable here in reserve for the project card.)
    </div>

    <div class="payments_type input-group" v-if="canUseSpireScience()">
      <i class="resource_icon resource_icon--science payments_type_icon" :title="$t('Pay with Science')"></i>
      <Button type="minus" :onClick="_=>reduceValue('spireScience', 1)" />
      <input class="form-input form-inline payments_input" v-model.number="spireScience" />
      <Button type="plus" :onClick="_=>addValue('spireScience', 1)" />
      <Button type="max" :onClick="_=>setMaxValue('spireScience')" title="MAX" />
    </div>

    <div class="payments_type input-group" v-if="canUseAsteroids()">
      <i class="resource_icon resource_icon--asteroid payments_type_icon" :title="$t('Pay with Asteroids')"></i>
      <Button type="minus" :onClick="_=>reduceValue('asteroids', 1)" />
      <input class="form-input form-inline payments_input" v-model.number="asteroids" />
      <Button type="plus" :onClick="_=>addValue('asteroids', 1)" />
      <Button type="max" :onClick="_=>setMaxValue('asteroids')" title="MAX" />
    </div>

    <div class="payments_type input-group" v-if="canUseGraphene()">
      <i class="resource_icon resource_icon--graphene payments_type_icon" :title="$t('Pay with Graphene')"></i>
      <Button type="minus" :onClick="_=>reduceValue('graphene', 1)" />
      <input class="form-input form-inline payments_input" v-model.number="graphene" />
      <Button type="plus" :onClick="_=>addValue('graphene', 1)" />
      <Button type="max" :onClick="_=>setMaxValue('graphene')" title="MAX" />
    </div>

    <div class="payments_type input-group" v-if="canUseTitanium()">
      <i class="resource_icon resource_icon--titanium payments_type_icon" :title="$t('Pay with Titanium')"></i>
      <Button type="minus" :onClick="_=>reduceValue('titanium', 1)" />
      <input class="form-input form-inline payments_input" v-model.number="titanium" />
      <Button type="plus" :onClick="_=>addValue('titanium', 1, this.available.titanium)" />
      <Button type="max" :onClick="_=>setMaxValue('titanium', this.available.titanium)" title="MAX" />
    </div>
    <div v-if="showReserveTitaniumWarning()" class="card-warning" v-i18n>
    (Some titanium is unavailable here in reserve for the project card.)
    </div>

    <div class="payments_type input-group" v-if="canUseHeat()">
      <i class="resource_icon resource_icon--heat payments_type_icon" :title="$t('Pay with Heat')"></i>
      <Button type="minus" :onClick="_=>reduceValue('heat', 1)" />
      <input class="form-input form-inline payments_input" v-model.number="heat" />
      <Button type="plus" :onClick="_=>addValue('heat', 1, this.available.heat)" />
      <Button type="max" :onClick="_=>setMaxValue('heat', this.availableHeat())" title="MAX" />
    </div>
    <div v-if="showReserveHeatWarning()" class="card-warning" v-i18n>
    (Some heat is unavailable here in reserve for the project card.)
    </div>

    <div class="payments_type input-group" v-if="canUseMicrobes()">
      <i class="resource_icon resource_icon--microbe payments_type_icon" :title="$t('Pay with Microbes')"></i>
      <Button type="minus" :onClick="_=>reduceValue('microbes', 1)" />
      <input class="form-input form-inline payments_input" v-model.number="microbes" />
      <Button type="plus" :onClick="_=>addValue('microbes', 1)" />
      <Button type="max" :onClick="_=>setMaxValue('microbes')" title="MAX" />
    </div>

    <div class="payments_type input-group" v-if="canUseFloaters()">
      <i class="resource_icon resource_icon--floater payments_type_icon" :title="$t('Pay with Floaters')"></i>
      <Button type="minus" :onClick="_=>reduceValue('floaters', 1)" />
      <input class="form-input form-inline payments_input" v-model.number="floaters" />
      <Button type="plus" :onClick="_=>addValue('floaters', 1)" />
      <Button type="max" :onClick="_=>setMaxValue('floaters')" title="MAX" />
    </div>

    <div class="payments_type input-group" v-if="canUseScience()">
      <i class="resource_icon resource_icon--science payments_type_icon" :title="$t('Pay with Science Resources')"></i>
      <Button type="minus" :onClick="_=>reduceValue('science', 1)" />
      <input class="form-input form-inline payments_input" v-model.number="science" />
      <Button type="plus" :onClick="_=>addValue('science', 1)" />
      <Button type="max" :onClick="_=>setMaxValue('science')" title="MAX" />
    </div>

    <div class="payments_type input-group">
      <i class="resource_icon resource_icon--megacredits payments_type_icon" :title="$t('Pay with Megacredits')"></i>
      <Button type="minus" :onClick="_=>reduceValue('megaCredits', 1)" />
      <input class="form-input form-inline payments_input" v-model.number="megaCredits" />
      <Button type="plus" :onClick="_=>addValue('megaCredits', 1)" />
    </div>
    <div v-if="showReserveMegaCreditsWarning()" class="card-warning" v-i18n>
    (Some M€ is unavailable here in reserve for Reds.)
    </div>

    <div v-if="hasWarning()" class="tm-warning">
      <label class="label label-error">{{ $t(warning) }}</label>
    </div>

    <div v-if="showsave === true" class="payments_save">
      <Button size="big" :onClick="saveData" :title="playerinput.buttonLabel" />
    </div>
  </section>
</div>`,
});
//# sourceMappingURL=SelectHowToPayForProjectCard.js.map